import * as React from "react"

import versionsBlock from "src/images/pages/liberica-native-image-kit/illustration-1.svg"
import versionsBlock2 from "src/images/pages/liberica-native-image-kit/illustration-2.svg"
import timeIC from "src/images/pages/liberica-native-image-kit/arrows.svg"
import settingIC from "src/images/pages/liberica-native-image-kit/code.svg"

export const products = [
    {
        title: 'A wide and unique variety\nof supported platforms',
        background: '#1D223B',
        body: (
            <>
                <p className="p-2 color-white">Linux x86_64 <span className="p-2 color-gray">(glibc)</span></p>
                <p className="p-2">&nbsp;</p>
                <p className="p-2 color-white">Linux Alpine x86_64 <span className="p-2 color-gray">(musl)</span></p>
                <p className="p-2">&nbsp;</p>
                <p className="p-2 color-white">Linux AArch64 <span className="p-2 color-gray">(glibc)</span></p>
                <p className="p-2">&nbsp;</p>
                <p className="p-2 color-white">Linux Alpine AArch64 <span className="p-2 color-gray">(musl)</span></p>
                <p className="p-2">&nbsp;</p>
                <p className="p-2 color-white">Mac OS x86_64</p>
                <p className="p-2">&nbsp;</p>
                <p className="p-2 color-white">Windows x86_64</p>
            </>
        ),
        image: versionsBlock,
        childrenClassNames: {
            title: 'color-white',
        },
        gridColumn: '1/5'
    },
    {
        title: 'Runs with most JDK versions',
        background: '#FFFFFF',
        body: (
            <>
                <p className="p-2">Update levels:</p>
                <p className="p-2">&nbsp;</p>
                <p className="p-2 color-gray">JDK 11.0.10 and newer</p>
                <p className="p-2 color-gray">GraalVM CE 21.0 and newer</p>
            </>
        ),
        icon: timeIC,
        gridColumn: '5/7'
    },
    {
        title: 'Multiple languages\ninteraction',
        background: '#FFFFFF',
        description: 'Most binaries already work with Java, JavaScript, LLVM, Python, Ruby, R, and WebAssembly, as do GraalVM Native Image™ binaries.',
        icon: settingIC,
        gridColumn: '1/4'

    },
    {
        title: 'Available for free',
        background: '#FFFFFF',
        description: 'Liberica NIK is free to download and use.\n',
        button: {
            caption: 'Download for free',
            href: '/pages/downloads/native-image-kit/'
        },
        image: versionsBlock2,
        gridColumn: '4/7',
        childrenClassNames: {
            button: 'button-bordered',
        }
    }
]
